/* eslint-disable react/require-default-props */
import React from 'react';
import {
  ActivityIndicator,
  Platform,
  TouchableOpacity,
  View,
} from 'react-native';
import {get} from 'lodash';

import Avatar from '/component/base/Avatar';
import Icon from '/component/base/Icon';
import Text from '/component/base/Text';
import {FEATURE_FLAGS_CONSTANT} from '/constant/featureFlag.constants';
import MyTeams from '/constant/TestIDs/MyTeams';
import {useFeatureFlag} from '/util/useFeatureFlag.util';

import {CoachInformation} from './TeamOrgReport';
import {
  getIndentStyle,
  getVerticalLineStyle,
  styles,
} from './TeamOrgReportList.style';
interface AccessibilityData {
  index?: number;
  totalCount?: number;
  reportMeta?: any;
  loadingData?: any;
}

interface CoachRowProps {
  item: CoachInformation;
  onPress: (item: CoachInformation, screenContext?: string) => void;
  isInWishlist: boolean;
  onToggleWishlist: () => void;
  indent: number;
  showChevron: boolean;
  isExpanded: boolean;
  onToggleExpand: () => void;
  formatNumber: (value: number | null | undefined) => string;
  level: number;
  showViewTeamButton: boolean;

  iswatchList: boolean;
  loading?: boolean;
  starLoading: boolean;
  onViewTeamPress: (item: CoachInformation) => void;
  // eslint-disable-next-line react/no-unused-prop-types
  tabsValue: string;
  viewTeamLoading: boolean;
  isViewTeam?: boolean;
  loginCoachId?: string | number;
  accessibilityData?: AccessibilityData;
  wishlistTestID?: string;
  expandTestID?: string;
}

const CoachRowItem = ({
  item,
  onPress,
  isInWishlist,
  onToggleWishlist,
  indent = 0,
  showChevron = false,
  isExpanded = false,
  onToggleExpand,
  formatNumber,
  level,
  showViewTeamButton = false,
  iswatchList,
  loading = false,
  starLoading = false,
  onViewTeamPress,
  viewTeamLoading,
  isViewTeam,
  loginCoachId,
  accessibilityData = {},
  wishlistTestID,
  expandTestID,
}: CoachRowProps) => {
  const {
    index = 0,
    totalCount = 0,
    reportMeta = null,
    loadingData = null,
  } = accessibilityData;

  const showteams_org_features = useFeatureFlag(
    FEATURE_FLAGS_CONSTANT.TEAMS_ORG_SR,
  );
  const shouldShowStar = isViewTeam || item.id !== loginCoachId;
  const isLoading = starLoading;
  const useWatchlistMetricLayout = iswatchList && Platform.OS !== 'web';

  const fullName = `${item.firstName} ${item.lastName}`;
  const total =
    get(reportMeta, 'page.total') ||
    get(reportMeta, 'report.total') ||
    get(loadingData, 'total', '');
  const totalNumber = Number(total) || 0;
  const profileAccessibilityLabel =
    Number.isFinite(index) && index >= 0 && totalNumber > 0
      ? `Open ${fullName} profile: ${index + 1} of ${totalNumber}`
      : totalCount > 0
      ? `Open ${fullName} profile: ${index + 1} of ${totalCount}`
      : `Open ${fullName} profile`;
  const getElementTestID = (baseId: string) =>
    iswatchList ? `${baseId}-${item.id}` : baseId;
  const onOpenProfile = () => {
    onPress?.(item);
  };

  return (
    <View style={styles.coachRowRoot}>
      {level >= 4 && (
        <View style={[styles.verticalLine, getVerticalLineStyle(indent)]} />
      )}

      <View
        testID={getElementTestID(MyTeams.coachRow)}
        style={[styles.rowWrapper, styles.rowWrapperColumn]}
        accessible={false}
        collapsable={false}
        onStartShouldSetResponder={() => !iswatchList}
        onResponderRelease={() => {
          if (!iswatchList) onOpenProfile();
        }}>
        <View
          style={[styles.itemContainer, getIndentStyle(indent)]}
          accessible={false}
          collapsable={false}>
          <View style={styles.chevronContainer}>
            {showChevron &&
              (loading ? (
                <ActivityIndicator size="small" color="#000" />
              ) : (
                <TouchableOpacity
                  testID={
                    expandTestID ??
                    getElementTestID(MyTeams.toggleDownlineCoach)
                  }
                  onPress={onToggleExpand}
                  accessibilityRole="button"
                  accessibilityState={{expanded: isExpanded}}
                  accessibilityLabel={
                    isExpanded ? 'Collapse Coach' : 'Expand Coach'
                  }>
                  <Icon
                    name={isExpanded ? 'arrow_drop_down' : 'arrow_right'}
                    style={styles.chevron}
                    testID={
                      isExpanded
                        ? getElementTestID(MyTeams.arrowDropDownIcon)
                        : getElementTestID(MyTeams.arrowRightIcon)
                    }
                  />
                </TouchableOpacity>
              ))}
          </View>

          <TouchableOpacity
            testID={getElementTestID(MyTeams.profileImage)}
            style={styles.avatar}
            onPress={onOpenProfile}
            accessible={true}
            accessibilityLabel={profileAccessibilityLabel}>
            <Avatar
              size={40}
              avatarUrl={item.avatarUrl}
              avatarKey=""
              isCoach={true}
            />
          </TouchableOpacity>

          <View style={styles.flex1}>
            <View style={styles.nameRow}>
              <View style={styles.nameAndBadgeRow}>
                <Text
                  testID={getElementTestID(MyTeams.coachName)}
                  style={styles.name}
                  isBold
                  onPress={onOpenProfile}
                  accessible={true}
                  accessibilityLabel={profileAccessibilityLabel}>
                  {item.firstName} {item.lastName}
                </Text>
                {level >= 4 && (
                  <View
                    testID={getElementTestID(MyTeams.verticalLine)}
                    style={[
                      styles.levelBadge,
                      level > 5
                        ? styles.l5AndAboveLevelBadge
                        : level === 5
                        ? styles.level5thLevel
                        : level === 4
                        ? styles.level4thLevel
                        : null,
                    ]}>
                    <Text
                      style={
                        level > 5
                          ? styles.l5AndAboveLevleText
                          : styles.levelText
                      }>
                      {`L${level}`}
                    </Text>
                  </View>
                )}
              </View>
              {/* {!item.isParentCoach && isViewTeam && starLoading ? (
                <ActivityIndicator size="small" color="#000" />
              ) : (
                <TouchableOpacity onPress={onToggleWishlist}>
                  <Icon
                    name={isInWishlist ? 'star_Filed' : 'starUnfilled'}
                    style={[
                      styles.starIcon,
                      isInWishlist ? styles.wishList : styles.UnwishList,
                    ]}
                    testID={isInWishlist ? 'star_Filed' : 'starUnfilled'}
                  />
                </TouchableOpacity>
              )} */}

              {shouldShowStar &&
                (isLoading ? (
                  <ActivityIndicator size="small" color="#000" />
                ) : (
                  <TouchableOpacity
                    testID={
                      wishlistTestID ??
                      getElementTestID(MyTeams.toggleWatchlist)
                    }
                    onPress={onToggleWishlist}
                    accessibilityRole="button"
                    accessibilityState={{selected: isInWishlist}}
                    accessibilityLabel={
                      isInWishlist
                        ? 'Remove from Watchlist'
                        : 'Add to Watchlist'
                    }>
                    <Icon
                      name={isInWishlist ? 'star_Filed' : 'starUnfilled'}
                      accessibilityLabel={
                        isInWishlist
                          ? 'Remove from Watchlist'
                          : 'Add to Watchlist'
                      }
                      style={[
                        styles.starIcon,
                        isInWishlist ? styles.wishList : styles.UnwishList,
                      ]}
                      testID={
                        isInWishlist
                          ? getElementTestID(MyTeams.removeFromWatchlist)
                          : getElementTestID(MyTeams.addToWatchlist)
                      }
                    />
                  </TouchableOpacity>
                ))}
            </View>

            <Text
              testID={getElementTestID(MyTeams.coachDescription)}
              style={styles.role}
              onPress={onOpenProfile}
              accessible={true}
              accessibilityLabel={profileAccessibilityLabel}>
              {item.rank?.description ?? '-'}
            </Text>
          </View>
        </View>

        <View
          style={[styles.statsBlock, getIndentStyle(indent)]}
          accessible={false}
          collapsable={false}>
          <View
            style={styles.statsRowLineWrap}
            accessible={false}
            collapsable={false}
            testID={getElementTestID(MyTeams.fqvDetails)}>
            {useWatchlistMetricLayout ? (
              <>
                <View style={styles.statsMetricRowItem}>
                  <Text
                    testID={getElementTestID(MyTeams.fqvLabel)}
                    style={[
                      styles.stats,
                      styles.statsNoShrink,
                      styles.statsMetricLabel,
                    ]}
                    accessible={true}
                    accessibilityLabel="FQV">
                    {'FQV '}
                  </Text>
                  <Text
                    testID={getElementTestID(MyTeams.fqvValue)}
                    style={[
                      styles.statsValue,
                      styles.boldStat,
                      styles.statsMetricValue,
                    ]}
                    accessible={true}
                    accessibilityLabel={formatNumber(item.fqv)}>
                    {formatNumber(item.fqv)}
                  </Text>
                </View>

                <View style={styles.statsMetricRowItem}>
                  <Text
                    testID={getElementTestID(MyTeams.fqvProjectedLabel)}
                    style={[
                      styles.stats,
                      styles.statsNoShrink,
                      styles.statsMetricLabel,
                    ]}
                    accessible={true}
                    accessibilityLabel="FQV Projected">
                    {'FQV Proj '}
                  </Text>
                  <Text
                    testID={getElementTestID(MyTeams.fqvProjectedValue)}
                    style={[
                      styles.statsValue,
                      styles.boldStat,
                      styles.statsMetricValue,
                    ]}
                    accessible={true}
                    accessibilityLabel={formatNumber(item.fqvProjected)}>
                    {formatNumber(item.fqvProjected)}
                  </Text>
                </View>

                <View style={styles.statsMetricRowItem}>
                  <Text
                    testID={getElementTestID(MyTeams.fqvEstimatedLabel)}
                    style={[
                      styles.stats,
                      styles.statsNoShrink,
                      styles.statsMetricLabel,
                    ]}
                    accessible={true}
                    accessibilityLabel="FQV Estimated">
                    {'FQV est. '}
                  </Text>
                  <Text
                    testID={getElementTestID(MyTeams.fqvEstimatedValue)}
                    style={[
                      styles.statsValue,
                      styles.boldStat,
                      styles.statsMetricValue,
                    ]}
                    accessible={true}
                    accessibilityLabel={formatNumber(
                      (Number(item.fqv) || 0) +
                        (Number(item.fqvProjected) || 0),
                    )}>
                    {formatNumber(
                      (Number(item.fqv) || 0) +
                        (Number(item.fqvProjected) || 0),
                    )}
                  </Text>
                </View>
              </>
            ) : (
              <>
                <Text
                  testID={getElementTestID(MyTeams.fqvLabel)}
                  style={[styles.stats, styles.statsNoShrink]}
                  accessible={true}
                  accessibilityLabel={`FQV ${formatNumber(item.fqv)}`}>
                  {'FQV '}
                  <Text
                    testID={getElementTestID(MyTeams.fqvValue)}
                    style={styles.boldStat}>
                    {formatNumber(item.fqv)}
                  </Text>
                </Text>

                <Text
                  testID={getElementTestID(MyTeams.fqvProjectedLabel)}
                  style={[styles.stats, styles.statsNoShrink]}
                  accessible={true}
                  accessibilityLabel={`FQV Projected ${formatNumber(
                    item.fqvProjected,
                  )}`}>
                  {'FQV Proj '}
                  <Text
                    testID={getElementTestID(MyTeams.fqvProjectedValue)}
                    style={styles.boldStat}>
                    {formatNumber(item.fqvProjected)}
                  </Text>
                </Text>

                <Text
                  testID={getElementTestID(MyTeams.fqvEstimatedLabel)}
                  style={[styles.stats, styles.statsNoShrink]}
                  accessible={true}
                  accessibilityLabel={`FQV Estimated ${
                    (Number(item.fqv) || 0) + (Number(item.fqvProjected) || 0)
                  }`}>
                  {'FQV est. '}
                  <Text
                    testID={getElementTestID(MyTeams.fqvEstimatedValue)}
                    style={styles.boldStat}
                    accessibilityLabel={`FQV Estimated ${
                      (Number(item.fqv) || 0) + (Number(item.fqvProjected) || 0)
                    }`}>
                    {formatNumber(
                      (Number(item.fqv) || 0) +
                        (Number(item.fqvProjected) || 0),
                    )}
                  </Text>
                </Text>
              </>
            )}
          </View>

          {showteams_org_features && (
            <View
              style={styles.statsRowLineWrap}
              testID={getElementTestID(MyTeams.fqvData)}>
              {useWatchlistMetricLayout ? (
                <>
                  <View style={styles.statsMetricRowItem}>
                    <Text
                      testID={getElementTestID(MyTeams.newClientCountLabel)}
                      style={[
                        styles.stats,
                        styles.statsNoShrink,
                        styles.statsMetricLabel,
                      ]}
                      accessible={true}
                      accessibilityLabel="New Clients">
                      {'New Clients '}
                    </Text>
                    <Text
                      testID={getElementTestID(MyTeams.newClientCountValue)}
                      style={[
                        styles.statsValue,
                        styles.boldStat,
                        styles.statsMetricValue,
                      ]}
                      accessible={true}
                      accessibilityLabel={formatNumber(
                        item.newClientCount || 0,
                      )}>
                      {formatNumber(item.newClientCount || 0)}
                    </Text>
                  </View>

                  <View style={styles.statsMetricRowItem}>
                    <Text
                      testID={getElementTestID(
                        MyTeams.newQualifiedClientCountLabel,
                      )}
                      style={[
                        styles.stats,
                        styles.statsNoShrink,
                        styles.statsMetricLabel,
                      ]}
                      accessible={true}
                      accessibilityLabel="New Qualified Clients">
                      {'New Qual. Clients '}
                    </Text>
                    <Text
                      testID={getElementTestID(
                        MyTeams.newQualifiedClientCountValue,
                      )}
                      style={[
                        styles.statsValue,
                        styles.boldStat,
                        styles.statsMetricValue,
                      ]}
                      accessible={true}
                      accessibilityLabel={formatNumber(
                        item.newQualClientCount || 0,
                      )}>
                      {formatNumber(item.newQualClientCount || 0)}
                    </Text>
                  </View>

                  <View style={styles.statsMetricRowItem}>
                    <Text
                      testID={getElementTestID(
                        MyTeams.newHealthCoachCountLabel,
                      )}
                      style={[
                        styles.stats,
                        styles.statsNoShrink,
                        styles.statsMetricLabel,
                      ]}
                      accessible={true}
                      accessibilityLabel="New Coaches Acq.">
                      {'New Coaches Acq. '}
                    </Text>
                    <Text
                      testID={getElementTestID(
                        MyTeams.newHealthCoachCountValue,
                      )}
                      style={[
                        styles.statsValue,
                        styles.boldStat,
                        styles.statsMetricValue,
                      ]}
                      accessible={true}
                      accessibilityLabel={formatNumber(
                        item.newHealthCoachCount || 0,
                      )}>
                      {formatNumber(item.newHealthCoachCount || 0)}
                    </Text>
                  </View>
                </>
              ) : (
                <>
                  <Text
                    testID={getElementTestID(MyTeams.newClientCountLabel)}
                    style={[styles.stats, styles.statsNoShrink]}
                    accessible={true}
                    accessibilityLabel={`New Clients ${formatNumber(
                      item.newClientCount || 0,
                    )}`}>
                    {'New Clients '}
                    <Text
                      testID={getElementTestID(MyTeams.newClientCountValue)}
                      style={styles.boldStat}>
                      {formatNumber(item.newClientCount || 0)}
                    </Text>
                  </Text>

                  <Text
                    testID={getElementTestID(
                      MyTeams.newQualifiedClientCountLabel,
                    )}
                    style={[styles.stats, styles.statsNoShrink]}
                    accessible={true}
                    accessibilityLabel={`New Qualified Clients ${formatNumber(
                      item.newQualClientCount || 0,
                    )}`}>
                    {'New Qual. Clients '}
                    <Text
                      testID={getElementTestID(
                        MyTeams.newQualifiedClientCountValue,
                      )}
                      style={styles.boldStat}>
                      {formatNumber(item.newQualClientCount || 0)}
                    </Text>
                  </Text>

                  <Text
                    testID={getElementTestID(MyTeams.newHealthCoachCountLabel)}
                    style={[styles.stats, styles.statsNoShrink]}
                    accessible={true}
                    accessibilityLabel={`New Coaches Acq. ${formatNumber(
                      item.newHealthCoachCount || 0,
                    )}`}>
                    {'New Coaches Acq. '}
                    <Text
                      testID={getElementTestID(
                        MyTeams.newHealthCoachCountValue,
                      )}
                      style={styles.boldStat}>
                      {formatNumber(item.newHealthCoachCount || 0)}
                    </Text>
                  </Text>
                </>
              )}
            </View>
          )}
        </View>

        {showViewTeamButton && item.isViewTeam && (
          <View
            style={[styles.buttonContainer, styles.alignSelfEnd]}
            testID={getElementTestID(MyTeams.viewTeamButtonContainer)}>
            <TouchableOpacity
              style={styles.viewTeamButton}
              testID={getElementTestID(MyTeams.viewTeamButton)}
              onPress={() => onViewTeamPress(item)}
              disabled={viewTeamLoading}
              accessibilityRole="button"
              accessibilityLabel="View Team">
              <View style={styles.viewTeamButtonInner}>
                <Text style={styles.buttonText}>View Team</Text>
                {viewTeamLoading && (
                  <ActivityIndicator
                    size="small"
                    style={styles.viewTeamLoadingIndicator}
                  />
                )}
              </View>
            </TouchableOpacity>
          </View>
        )}
      </View>
    </View>
  );
};

export default CoachRowItem;
